import { render, staticRenderFns } from "./ReportMealsTabReservedMeals.vue?vue&type=template&id=d82487a6&scoped=true"
import script from "./ReportMealsTabReservedMeals.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabReservedMeals.vue?vue&type=script&lang=js"
import style0 from "./ReportMealsTabReservedMeals.vue?vue&type=style&index=0&id=d82487a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82487a6",
  null
  
)

export default component.exports